import appGlobalScript from 'E:/WORKSPACE/astral-ui/src/global/ts/entry.ts';
export const globalScripts = appGlobalScript;
